import useIsInMiniHeroExperiment from '~/hooks/vdp/useIsInMiniHeroExperiment';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';

export default function useShouldHideSectionsForMiniHero() {
  const isInMiniHeroExperiment = useIsInMiniHeroExperiment();
  const shouldRenderCondensedHero = useShouldRenderCondensedHero();

  return isInMiniHeroExperiment && shouldRenderCondensedHero;
}
